import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatRadioChange } from '@angular/material';
import { Preferences } from '../../model/preferences.model';
import { AttributeCode, InvestmentPreference } from '../../model/finzy-flex/user-attribute.model';
import { cloneDeep, find, forEach, remove, some } from 'lodash';

@Component({
  selector: 'app-loan-tenure-selector',
  templateUrl: './loan-tenure-selector.component.html',
  styleUrls: ['./loan-tenure-selector.component.scss']
})
export class LoanTenureSelectorComponent implements OnInit {

  public loanTenureOptions: number[] = [12, 24, 36];
  public loanTenure: number;

  @Input()
  public readonly investmentPreferences: InvestmentPreference[];

  @Output()
  public readonly preferredInvestmentPreferencesChange = new EventEmitter<InvestmentPreference[]>();

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.getLoanLoanTenure();
  }

  private getLoanLoanTenure() {
    const investmentPreference: InvestmentPreference = this.getPreferredLoanTenure();
    if (investmentPreference) {
      this.loanTenure = parseInt(investmentPreference.attributeValue);
    } else {
      this.loanTenure = 36;
const selectedInvestmentPreference: InvestmentPreference = {
        attributeCode: AttributeCode.PRO_PREFERRED_LOAN_TENURE,
        attributeValue: this.loanTenure
      };
      this.investmentPreferences.push(cloneDeep(selectedInvestmentPreference));
    }
    console.log("Before set", this.investmentPreferences);
  }

  public setCustomPortfolioPreference(value: number, data: MatRadioChange): void {
    console.log(value, data.source);
if (value && this.getPreferredLoanTenure()) {
      this.updateInvestmentPreference(value);
    } 
    this.preferredInvestmentPreferencesChange.emit(this.investmentPreferences);
    console.log("After set", this.investmentPreferences);
  }

  public updateInvestmentPreference(value: number) {
    if (value) {
      forEach(this.investmentPreferences, (investmentPreference: InvestmentPreference) => {
        if (investmentPreference.attributeCode === AttributeCode.PRO_PREFERRED_LOAN_TENURE) {
          return investmentPreference.attributeValue = value.toString();
        }
      })
    }
  }

  private getPreferredLoanTenure(): InvestmentPreference {
    return find(this.investmentPreferences, ['attributeCode', AttributeCode.PRO_PREFERRED_LOAN_TENURE]);
  }
}
